var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errors.length)?_c('div',{staticClass:"notification is-danger"},[_c('button',{staticClass:"delete",on:{"click":function($event){_vm.errors = []}}}),_vm._l((_vm.errors),function(error,index){return _c('div',{key:index},[_c('b',[_vm._v(_vm._s(error))])])})],2):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eae48150","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error/ErrorNotification.vue
// module id = null
// module chunks = 